import React, {useEffect, useState} from 'react';
import {Image, Modal} from 'react-native';
import Button from '../components/Button';
import {useNavigation} from '@react-navigation/native';
import MainStyle from "../../MainStyle";
import bg from "../assets/img/Group 2494.png";
import Div from "../lib/Div";
import {colors} from "../assets/styles/colors";
import P from "../lib/P";

type Props = { visible: boolean, onClose: () => void, email: string };

const EmailNotExistModal = (props: Props) => {
  const {visible, email} = props;
  const navigation: any = useNavigation();
  const [bgColor, setBgColor] = useState('transparent');

  const createNewAccount = () => {
    props.onClose();
    navigation.navigate({name: 'Register', params: {email}});
  };

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        setBgColor(colors.popupDropBg);
      }, 400);

    } else {
      setBgColor('transparent');
    }
  }, [visible]);

  return (
    <Modal animationType="slide" transparent visible={visible} onRequestClose={props.onClose}>
      <Div flex={1} zIndex={2} bg={bgColor}>
        <Div flex={1}/>

        <Div w="100%" maxW={430} mx="auto" position="relative" bg={colors.loading_login} borderHorizontalWidth={1}
             borderColor={colors.settings_border}>
          <Image source={bg as any} style={styles.image} resizeMode="center"/>

          <P ta="center" fw="500" mb={22}>{`You do not have an account with this\nemail address.`}</P>

          <P ta="center" fs={18} fw="700" mb={27}>Do you want to create a new account?</P>

          <Div px={18} mb={60} column>
            <Button text="Create a New Account" onPress={createNewAccount} w="100%" mb={20}/>

            <Button
              text="Re-Enter Email" onPress={props.onClose} w="100%" bg="transparent" color="white"
              borderWidth={1} borderColor="white"
            />
          </Div>
        </Div>
      </Div>
    </Modal>
  );
};

const styles = {
  image: [MainStyle.h_368, MainStyle.absolute, MainStyle.t__70, MainStyle.z_i__1, MainStyle.l__1, MainStyle.r__1]
};

export default React.memo(EmailNotExistModal);
